import css from '@emotion/css'

import sound from '../images/sound.png'

export default css`
    .sprite {
        animation-duration: 0.2s;
        animation-fill-mode: forwards;
        animation-timing-function: steps(6);
        background-image: url(${sound});
        background-repeat: no-repeat;
        cursor: pointer;
        display: inline-block;
        height: 47px;
        overflow: hidden;
        position: absolute;
        right: 120px;
        top: 60px;
        transform: scale(0.5);
        transform-origin: center;
        width: 48px;
        z-index: 1;

        &.is-on {
            animation-name: play;
        }

        &.is-off {
            animation-name: playB;
        }
    }

    .Composition-2_106 {
        width: 48px;
        height: 47px;
        background-position: -288px -0px;
    }

    @keyframes play {
        0% {
            background-position: 0px;
        }
        100% {
            background-position: -288px;
        }
    }

    @keyframes playB {
        0% {
            background-position: -288px;
        }
        100% {
            background-position: 0px;
        }
    }
`
